export default {
  sellerInfoAction({ commit }, data) {
    commit("sellerInfoMutation", data);
  }
};
